/** Thrown when user exists but has not finished the registration wizard. */
export class RegistrationIncompleteError extends Error {
  readonly code = 'REGISTRATION_INCOMPLETE';

  constructor(
    readonly mobile: string,
    readonly token: string,
  ) {
    super('Registration must be completed');
    this.name = 'RegistrationIncompleteError';
  }
}

export function isRegistrationIncompleteError(e: unknown): e is RegistrationIncompleteError {
  return e instanceof RegistrationIncompleteError;
}
